import { render, staticRenderFns } from "./GroupMessageArea.vue?vue&type=template&id=63fde0fe&scoped=true"
import script from "./GroupMessageArea.vue?vue&type=script&lang=js"
export * from "./GroupMessageArea.vue?vue&type=script&lang=js"
import style0 from "./GroupMessageArea.vue?vue&type=style&index=0&id=63fde0fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fde0fe",
  null
  
)

export default component.exports